define('toolkit/b-select/b-select', function (require) {
	'use strict';

	var toolkit = require('toolkit/b-toolkit/b-toolkit');

	require('toolkit/b-dropdown/b-dropdown');

	var MODS_MULTISELECT = 'multiselect';
	var TEXT_EMPTY = '';
	var TEXT_FULL = '';
	var FILTER_ALL = 0;
	var FILTER_ENABLED = 1;
	var FILTER_DISABLED = 2;
	var TAB_KEY = 9;
	var ARROW_DOWN_KEY = 40;
	var ARROW_UP_KEY = 38;
	var SPACE_KEY = 32;
	var ENTER_KEY = 13;

	return toolkit.create('b-select', {

		toggle: function(item) {
			this._toggleItem(item);
			var value = [];
			for (var i = 0; i < this._selectedItem.length; i++) {
				value.push(this._selectedItem[i].value);
			}
			this.$('__input').val(value.join(','));
			this.dropdown.setCurrentItem(item);

			this.updateTitle();
		},

		/**
		 * Передаем модификатор дальше дочерним блокам
		 *
		 * @param mod
		 * @param state
		 */
		toggleMod: function(mod, state) {
			toolkit['b-toolkit'].fn.toggleMod.call(this, mod, state);

			this.dropdown.toggleMod(mod, state);
			this.$select.toggleMod(mod, state);
		},

		select: function(item) {
			this.$('__input').val(item.value);
			this._selectedItem = [item];
			this.dropdown.setCurrentItem(item);

			this.$select.val(item.value);

			if (item.image) {
				this.$select.css({'background-image': 'url(' + item.image + ')'});
			} else {
				this.$select.css({'background-image': 'none'});
			}

			this.toggleMod('select-has-image', !!item.image);
		},

		setValue: function (value) {
			var item = this._getItemFromValue(value);
			if (this.hasMod(MODS_MULTISELECT)) {
				this.toggle(item);
			} else {
				this.select(item);
			}

			// удаляем модификатор который оформляет состояние до первого выбора
			if (this.hasMod('style-on-start')) {
				this.toggleMod('style-on-start', false);
			}
		},

		init: function () {
			var items = this.data.items || [],
				selected;

			if (items) {
				items = items.map(function (item, i) {
					item.num  = i;

					return item;
				});
			}

			this.initInner();

			var defaultIndex = this.data.defaultIndex;

			this.dropdown = this.$('[data-bem="b-dropdown"]').getBlock();
			this.data.props = this.data.props || {};
			this.updateTitle = toolkit.debounce(this._updateTitle, 100);

			this.dropdown.on('item', function ($event, event) {
				var item = event.$el.data();

				if (!item.value && item.value !== 0) {
					item.value = "";
				}

				if (this.hasMod(MODS_MULTISELECT)) {
					this.toggle(item);
				} else {
					this.select(item);
				}

				// удаляем модификатор который оформляет состояние до первого выбора
				if (this.hasMod('style-on-start')) {
					this.toggleMod('style-on-start', false);
				}

				this.emit('change', item);
			}.bind(this));

			this.dropdown.on('expand', function () {
				this.emit('expand');
			}.bind(this));

			this.$select = this.$('.b-select__list');
			this.$select.on('change', this._onNativeSelectChange.bind(this));

			this.dropdown.on('toggleall', function ($event, event) {
				var item = event.$el.data();

				var allEnabledItems = this._getItems(FILTER_ENABLED);
				if (this._selectedItem.length === allEnabledItems.length) {
					// Выделены все, снимаем выделение со всех
					while (this._selectedItem.length) {
						this.toggle(this._selectedItem[0]);
					}
				} else {
					// Выделяем все не выделенные
					for (var i = 0; i < allEnabledItems.length; i++) {
						var _item = allEnabledItems[i];
						var selected = false;
						for (var j = 0; j < this._selectedItem.length; j++) {
							if (this._selectedItem[j].num === _item.num) {
								selected = true;
							}
						}
						if (!selected) {
							this.toggle(_item);
						}
					}
				}

				this.emit('change', item);

			}.bind(this));

			selected = items.filter(function (item) {
				return item.selected;
			});

			if (this.hasMod(MODS_MULTISELECT)) {
				for (var i = 0; i < selected.length; i++) {
					this.toggle(selected[i]);
				}
			} else {
				if (selected.length) {
					this.select(selected[0]);
				} else if((defaultIndex !== void 0) && items[defaultIndex])
				// Если есть индекс по умолчанию то выставляем его
				{
					this.select(items[defaultIndex]);
				} else if (items[0] && !this.data.props.placeholder){
					this.select(items[0]);
				}
			}

			this.$el
				.on('focus.' + this.uniqid, this._onToggleFocus.bind(this))
				.on('blur.' + this.uniqid, this._onToggleFocus.bind(this))
				.on('keydown.' + this.uniqid, this._onKeyDown.bind(this));

			return this;
		},

		_onToggleFocus: function (evt) {
			this.toggleMod('focused', evt.type === 'focus');

			if (!this.hasMod('focused')) {
				this.dropdown.hide();
			}
		},

		/**
		 * Метод обрабатывает события нажатий клавишь при выбраном селекте
		 * */
		_onKeyDown: function (evt) {

			if (this.hasMod('disabled')) {
				return;
			}

			if (evt.which === TAB_KEY) {
				// если мод есть, то устанавливаем текущее активное значение
				// только для одиночного выбора
				if (this.hasMod('save-after-tab') && !this.hasMod(MODS_MULTISELECT)) {
					if (!this.dropdown.selectCurrentItem()) {
						this.dropdown.hide();
					}
				} else {
					this.dropdown.hide();
				}
			}

			if (evt.which === TAB_KEY || this.dropdown.isExpanded()) {
				return;
			}

			if (evt.which === ARROW_DOWN_KEY
				|| evt.which === SPACE_KEY
			 	|| evt.which === ENTER_KEY
				|| evt.which === ARROW_UP_KEY ) {

				this.dropdown.expand();
			}

		},

		/**
		 * Обработка нативного события для элемента select
		 *
		 * @private
		 */
		_onNativeSelectChange: function() {
			var value = this.$select.val();

			this.setValue(value);

			// удаляем модификатор который оформляет состояние до первого выбора
			if (this.hasMod('style-on-start')) {
				this.toggleMod('style-on-start', false);
			}

			this.emit('change', this._getItemFromValue(value));
		},

		render: function () {
			toolkit['b-toolkit'].prototype.render.apply(this, arguments);

			if (this.dropdown) {
				this.dropdown.destroy();
				this.init();
			}

			return this;
		},

		destroy: function () {
			this.dropdown.destroy();
			this.dropdown = null;
			toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
		},

		getValue: function () {
			if (this.hasMod(MODS_MULTISELECT)) {
				return this._selectedItem;
			} else {
				return this._selectedItem[0]||null;
			}
		},

		_selectedItem: [],

		_onSelectItem: function () {},

		_toggleItem: function(item) {
			var index = -1;
			var cnt = 0;
			while ((cnt < this._selectedItem.length) && index == -1) {
				if (this._selectedItem[cnt].num === item.num) {
					index = cnt;
				}
				cnt++;
			}
			if ( index != -1 ) {
				this._selectedItem.splice(index, 1);
			} else {
				this._selectedItem.push(item);
			}

			this._selectedItem.sort(function(a, b){
				if (a.num === b.num) {
					return 0;
				} else if (a.num > b.num) {
					return 1;
				} else {
					return -1;
				}
			});
		},

		_getItems: function(filter) {
			if (!filter) {
				filter = FILTER_ALL;
			}
			var items = this.data.items;
			var _items = [];
			for (var i = 0; i < items.length; i++) {
				if (filter === FILTER_ALL) {
					_items.push(items[i]);
				} else if (filter === FILTER_ENABLED && !items[i].disabled) {
					_items.push(items[i]);
				} else if (filter === FILTER_DISABLED && items[i].disabled) {
					_items.push(items[i]);
				}
			}

			return _items;
		},

		_updateTitle: function() {
			var title = [];
			var allEnabledItems = this._getItems(FILTER_ENABLED);
			if ( this._selectedItem.length === allEnabledItems.length ) {
				title.push(this.data.props.allChecked||'');
			} else if (this._selectedItem.length === 0) {
				title.push(this.data.props.notChecked||'');
			} else {
				for (var i = 0; i < this._selectedItem.length; i++) {
					title.push(this._selectedItem[i].text);
				}
			}
			this.dropdown.setTitle(title.join(', '));
		},

		/**
		 * Получаем объект описывающий айтем, по строке value
		 *
		 * @param {string} val
		 * @private
		 *
		 * @return
		 */
		_getItemFromValue: function(val) {
			var result = null;
			this.data.items.forEach(function(item){
				if(result) return;

				if(item.value == val){
					result = item;
				}
			});
			return result;
		}

	});

});
